export default __webpack_public_path__ + "static/media/barbara-de-muro.fc587d2b.svg";